import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TreeNode } from '../../models/tree-models';

// -------------------------------------------------------------------------------------------------------------------

@Component({
  selector: 'app-modal-new-folder',
  templateUrl: './modal-new-folder.component.html',
  styleUrls: ['./modal-new-folder.component.scss']
})
export class ModalNewFolderComponent implements OnInit {
  newFolderForm: FormGroup;
  excludedCharPattern = /^[^\\\/:*?"<>|]+(\.[^\\\/:*?"<>|]+)*$/;
  othersFoldersName = [];

  // -------------------------------------------------------------------------------------------------------------------

  constructor(
    public dialogRef: MatDialogRef<ModalNewFolderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { folder: TreeNode; folders: TreeNode[] },
    public dialog: MatDialog,
    private fb: FormBuilder
  ) {}

  // -------------------------------------------------------------------------------------------------------------------

  ngOnInit() {
    if (this.data?.folders) {
      this.othersFoldersName = this.data.folders.map((f) => f.name);
    }
    this.initFormUpload();
  }

  // -------------------------------------------------------------------------------------------------------------------

  folderNameValidator(existingFolders: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // Se il campo è vuoto, è valido
      }

      const folderName = control.value.trim().toLowerCase();
      const isInvalid = existingFolders.some((folder) => folder.toLowerCase() === folderName);

      return isInvalid ? { folderExists: true } : null;
    };
  }

  // -------------------------------------------------------------------------------------------------------------------

  initFormUpload = () => {
    const folder = this.data?.folder;
    const actualName = folder ? folder?.name : '';
    const validators = [
      Validators.required,
      Validators.pattern(this.excludedCharPattern),
      this.folderNameValidator(this.othersFoldersName)
    ];

    const controls = { nome_cartella: [actualName, [...validators]] };
    this.newFolderForm = this.fb.group(controls);
  };

  // -------------------------------------------------------------------------------------------------------------------

  confirm() {
    const { nome_cartella } = this.newFolderForm.controls;

    if (!this.data?.folder) {
      this.dialogRef.close({ new: true, folder: { name: nome_cartella.value } });
      return;
    }

    if (this.data?.folder) {
      const sameName = nome_cartella?.value.toLowerCase() === this.data?.folder?.name.toLowerCase();
      if (sameName) {
        this.close();
        return;
      }
    }

    this.dialogRef.close({ new: true, folder: { name: nome_cartella.value } });
  }

  // -------------------------------------------------------------------------------------------------------------------

  close(response?: { new: boolean; folder: any }) {
    this.dialogRef.close(response);
  }
}
